import { type UseFormReturn, useWatch } from 'react-hook-form'

import NomenclatureHierarchyPanel from '@/components/NomenclatureImport/NomenclatureHierarchyPanel/NomenclatureHierarchyPanel'
import { useTreeTilesStore } from '@/stores/feed/treeTilesStore'

import type { NomenclatureDictionaries } from '../hooks/useNomenclatureDictionaries'
import type { NomenclatureCreationType } from '../SingularImport.config'

type NomenclatureHierarchyFieldsProps = {
  form: UseFormReturn<NomenclatureCreationType>
  dictionaries: NomenclatureDictionaries
  maxHeight: number | null
  isOrganisationSelected: boolean
}

function NomenclatureHierarchyFields({
  form,
  dictionaries,
  maxHeight,
  isOrganisationSelected,
}: NomenclatureHierarchyFieldsProps) {
  const [groupId, categoryId] = useWatch({
    control: form.control,
    name: ['nomenclatureGroup', 'category'],
  })
  const setCategoriesTree = useTreeTilesStore(
    (state) => state.setCategoriesTree
  )
  const setNomenclatureGroupsTree = useTreeTilesStore(
    (state) => state.setNomenclatureGroupsTree
  )
  const { errors } = form.formState

  const selectValue = (name: 'nomenclatureGroup' | 'category', id: string) =>
    form.setValue(name, id, { shouldDirty: true, shouldValidate: true })

  return (
    <NomenclatureHierarchyPanel
      maxHeight={maxHeight}
      nomenclatureGroupsTree={dictionaries.nomenclatureGroupsTree}
      antdNomenclatureGroupsTree={dictionaries.antdNomenclatureGroupsTree}
      categoriesTree={dictionaries.categoriesTree}
      antdCategoriesTree={dictionaries.antdCategoriesTree}
      selectedGroupId={groupId}
      selectedCategoryId={categoryId}
      groupErrorMessage={errors.nomenclatureGroup?.message}
      categoryErrorMessage={errors.category?.message}
      onGroupSelect={(id) => selectValue('nomenclatureGroup', id)}
      onCategorySelect={(id) => selectValue('category', id)}
      setNomenclatureGroupsTree={setNomenclatureGroupsTree}
      setCategoriesTree={setCategoriesTree}
      onGroupCreated={dictionaries.reloadNomenclatureGroups}
      onCategoryCreated={dictionaries.reloadCategories}
      isOrganisationSelected={isOrganisationSelected}
    />
  )
}

export default NomenclatureHierarchyFields
